import {
    GESTION_OPERATIVA_SALE_REPORT_FILE_BEGIN,
    GESTION_OPERATIVA_SALE_REPORT_FILE_SUCCESS,
    GESTION_OPERATIVA_SALE_REPORT_FILE_FAILURE,
    GESTION_OPERATIVA_SALE_REPORT_FILE_DISMISS_ERROR,
  } from './constants';
  import { BFFAgent } from '../../../common/BFFAgent';
  
export function reportSales(args = {}) {
    return async (dispatch) => {
        dispatch({
            type: GESTION_OPERATIVA_SALE_REPORT_FILE_BEGIN,
        });

        try {
            const res = await BFFAgent.GestionOperativa.getSalesReport(args)

            // TODO: maybe generate a helper function
            const link = document.createElement('a');
            link.href = res.downloadUrl;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            dispatch({
                type: GESTION_OPERATIVA_SALE_REPORT_FILE_SUCCESS,
                data: res,
            });
        } catch(err) {
            dispatch({
                type: GESTION_OPERATIVA_SALE_REPORT_FILE_FAILURE,
                data: { error: err },
            });
            return Promise.reject(err)
        }
    }
}
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissReportPeritadorError() {
    return {
      type: GESTION_OPERATIVA_SALE_REPORT_FILE_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case GESTION_OPERATIVA_SALE_REPORT_FILE_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          reportSalesPending: true,
          reportSalesError: null,
        };
  
      case GESTION_OPERATIVA_SALE_REPORT_FILE_SUCCESS:
        // The request is success
        return {
          ...state,
          reportSalesPending: false,
          reportSalesError: null,
        };
  
      case GESTION_OPERATIVA_SALE_REPORT_FILE_FAILURE:
        // The request is failed
        return {
          ...state,
          reportSalesPending: false,
          reportSalesError: action.data.error,
        };
  
      case GESTION_OPERATIVA_SALE_REPORT_FILE_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          reportSalesError: null,
        };
  
      default:
        return state;
    }
  }
  
